import {
  Form,
  Input,
  Modal,
  Select,
  DatePicker,
  Tooltip,
  message,
  Tag,
  Space,
  Button,
} from "antd";
import React, { forwardRef, useEffect, useState, useRef } from "react";
import { MailOutlined, CheckOutlined, CloseOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
// import "./CompletedTable.scss";
import moment from "moment";
import parse from "html-react-parser";
import PDFModal from "@/views/AccountPayable/ApprovalSummary/component/PDFModal";
import { useLocation } from "react-router-dom";
import commonFn from "@/utils/commonFn";
import { CustomTable, CustomTableExtend } from "@/hocComponents";
const MainTable = forwardRef((props, ref) => {
  const location = useLocation();
  const [selectedList, setSelectedList] = useState([]);
  const [openApproval, setOpenApproval] = useState(false);
  const [approvalForm] = Form.useForm();
  const [printForm] = Form.useForm();
  const [printCheckForm] = Form.useForm();
  const [onlyForm] = Form.useForm();
  const [openPrintModal, setOpenPrintModal] = useState(false);
  const [openPrintCheckModal, setOpenPrintCheckModal] = useState(false);
  const [openOnlyModal, setOpenOnlyModal] = useState(false);
  const [currentRecord, setCurrentRecord] = useState(null);
  const [payByList, setPayByList] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [approvedOrRejected, setApprovedOrRejected] = useState("Approved");
  const initTableHead = {
    trust: null,
    prop: null,
    street: null,
    numberOfUnits: null,
    name: null,
    vendid: null,
    glAcct: null,
    amount: null,
    bank: null,
    customerAccount: null,
    invoice: null,
    invoiceDate: null,
    remark: null,
    udate: null,
  };
  const [tableHead, setTableHead] = useState(initTableHead);

  const tableFilterFn = (event, key, type = "Input") => {
    commonFn.tableFilterFn({ event, key, type, setTableHead, getTableListFn });
  };

  const initColumns = [
    // {
    //   title: "#",
    //   dataIndex: "#",
    //   width: 50,
    // },
    {
      title: 'Pay Amount',
      dataIndex: "requestPay",
      titleType: '',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'requestPay'),
      render: (text, record) => {
        if (text == null || text === "") return "-";
        return (
          <span
            onClick={() => handleAmountClick(record)}
            className="CA-AS-AmountStyle"
          >
            <div style={{ fontSize: '16px' }}>{commonFn.amountToDollarFn(text)}</div>
            {text ? <div>{record.contractor}</div> : null}
          </span>
        )
      },
    },
    {
      title: 'Other Pay Amount',
      dataIndex: "otherRequestAmount",
      titleType: '',
      isSorter: true,
      sortterMultiple: 3,
       width:100,
      onChange: e => tableFilterFn(e, 'otherRequestAmount'),
      render: (text, record) => {
        if (text == null || text === "") return "-";
        return (
          <span
            onClick={() => handleAmountClick(record)}
            className="CA-AS-AmountStyle"
          >
            <div>{commonFn.amountToDollarFn(text)}</div>
            {text ? <div>{record.contractor}</div> : null}
          </span>
        )
      },
    },
    {
      title: 'Remark',
      dataIndex: "remark",
      // titleType: 'Input',
      width:180,
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'remark'),
    },
    {
      title: "GL-Title",
      dataIndex: "glAcct",
      // titleType: "Input",
      width: 160,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, 'glAcct'),
    },
    {
      title: 'Project Manager',
      dataIndex: "managerName",
      // titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'managerName'),
    },
    {
      title: 'Project Name',
      dataIndex: "projectName",
      // titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'projectName'),
    },
    {
      title: "Prop - Address, City State",
      dataIndex: "addressCityStateZip",
      // titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
       width:250,
      onChange: (e) => tableFilterFn(e, "addressCityStateZip"),
    },
    {
      title: 'Remaining',
      dataIndex: "remainingAmount",
      titleType: '',
      isSorter: true,
      sortterMultiple: 3,
      isAmountFlag: true,
      onChange: e => tableFilterFn(e, 'remainingAmount'),
    },
    {
      title: 'Total Other Paid',
      dataIndex: "contractedOtherAmount",
      titleType: '',
      isSorter: true,
      sortterMultiple: 3,
      isAmountFlag: true,
      onChange: e => tableFilterFn(e, 'contractedOtherAmount'),
    },
    {
      title: 'Orginal Contracted',
      dataIndex: "projectAmount",
      titleType: '',
      isSorter: true,
      sortterMultiple: 3,
      isAmountFlag: true,
      onChange: e => tableFilterFn(e, 'projectAmount'),
    },
    {
      title: 'Change Order',
      dataIndex: "co",
      titleType: '',
      isSorter: true,
      sortterMultiple: 3,
      isAmountFlag: true,
      onChange: e => tableFilterFn(e, 'co'),
    },
  ];

  const [columns, setColumns] = useState(initColumns);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });
  const [btnLoading, setBtnLoading] = useState(false);
  // 提交数据
  const handleSubmit = async () => {
    setBtnLoading(true);

    try {
      const values = await approvalForm.validateFields();
      const data = {
        ...values,
        ids: selectedList.map((item) => item.vendorPaymentId),
        approvedOrRejected,
        batchGroup: getPropsParamsFn().batch,
      };
      const response = await http.post(api.getCheckApprovalApprove, data);
      if (response.code === "1") {
        message.success(`${approvedOrRejected} success!`);
        setOpenApproval(false);
        // 清空所有选中状态
        setSelectedList([]);
        setSelectedRowKeys([]);
        setSelectedRows([]);

        // 刷新表格
        setRefreshKey(Date.now());
      } else {
        message.error(`${approvedOrRejected} failed!`);
      }
    } catch (error) {
      console.error(error);
    }

    setBtnLoading(false);
  };

  const initialValues = {
    postDate: moment().startOf("day"),
  };

  const handleDateChange = (date) => {
    return date ? date.clone() : null;
  };

  const handlePrintSubmit = () => {
    printForm.validateFields().then((values) => {
      console.log("打印数据:", {
        ...values,
        postDate: values.postDate.format("MM/DD/YYYY"),
      });

      setOpenPrintCheckModal(false);
    });
  };

  const handleDateCheckChange = (date) => {
    return date ? date.clone() : null;
  };

  const initialCheckValues = {
    postDate: moment().startOf("day"),
  };

  const initialOnlyValues = {
    postDate: moment().startOf("day"),
  };

  const handleDateOnlyChange = (date) => {
    return date ? date.clone() : null;
  };

  const getDictionaryFn = async (value) => {
    const params = {
      type: "util_payment",
      value,
    };
    const response = await http.get(api.getDictionary, { params });
    switch (value) {
      case "payBy":
        setPayByList(response);
        break;
      default:
        break;
    }
  };

  const initColunmsFn = () => {
    setSelectedList([]);
    setTableHead(initTableHead);
    setColumns(initColumns);
  };

  useEffect(() => {
    getDictionaryFn("payBy");
  }, []);

  useEffect(() => {
    initColunmsFn();
    getTableListFn(1, 25);
  }, [refreshKey]);

  const PDFModalRef = useRef();

  const handleAmountClick = (record) => {
    const route = `/AccountPayable/CAMajorProjectAPDetail?id=${record.id}&projectName=${record.contractor}&contractId=${record.contractorId}&foreignId=${record.foreignId}`
    const url = `${window.location.origin}#${route}`;
    window.open(url, "_blank", "noopener,noreferrer");
    // setCurrentRecord({
    //   ...record,
    //   pageName: "MajorProject",
    //   type: "major_project",
    // });
    // PDFModalRef?.current?.setModalOpen(true);
  };

  //列表
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    setTableLoading(true);
    const params = {
      page: current || pagination.current,
      count: pageSize || pagination.pageSize,
      ...tableHead,
      usid: new URLSearchParams(location.search).get("email"),
      type: new URLSearchParams(location.search).get("module"),
      batch: new URLSearchParams(location.search).get("batch"),
    };
    const response = await http.get(api.getCheckMajorProject, { params });
    if (response?.code !== "1") {
      commonFn.modalFailedFn(response);
      setTableLoading(false);
      return;
    }
    const list = (response.data.list || []).map((item, index) => ({
      ...item,
      "#": (params.page - 1) * params.count + index + 1,
    }));
    //  setSelectedList([]);
    setTableList(list);
    setPagination((prev) => ({
      ...prev,
      total: response.data.total || 0,
      current: params.page,
      pageSize: params.count,
    }));
    setTableLoading(false);
  };
  const handleTableChange = (pagination, filters, sorter) => {
    getTableListFn(pagination.current, pagination.pageSize, filters);
  };

  const rowSelection = {
    selectedRowKeys,
    type: "checkbox",
    getCheckboxProps: (record) => ({
      style: record.isEmpty ? { display: "none" } : {},
      // disabled: record.approve === "Waiting For Approval",
    }),
    onChange: (selectedRowKeys, selectedRows) => {
      // console.log(selectedRowKeys);
      setSelectedRowKeys(selectedRowKeys);
      setSelectedRows(selectedRows);
      setSelectedList(selectedRows);
      // console.log(selectedRows);
    },
    preserveSelectedRowKeys: true,
  };

  const approveOrRejectFn = (approvedOrRejected) => {
    // console.log(selectedRowKeys);
    if (!selectedList.length) {
      message.warning("Please select at least one item");
      return;
    }
    setOpenApproval(true);
    setApprovedOrRejected(approvedOrRejected);
    // 设置表单初始值，包括默认日期
    approvalForm.setFieldsValue({
      transactionCount: "1",
      noLimit: "no",
    });
  };
  const getPropsParamsFn = () => {
    const searchParams = new URLSearchParams(location.search);

    const params = {};
    for (const [key, value] of searchParams.entries()) {
      params[key] = value;
    }
    return params;
  };
  return (
    <div>
      <CustomTableExtend
        columns={columns}
        setColumns={setColumns}
        initColumns={initColumns}
        refreshKey={refreshKey}
        setRefreshKey={setRefreshKey}
        noShowList={[
          !commonFn.btnAuthorityFlag("DetailDownload") && "download",
        ]}
      >
        <div className="topLeft">
          <Space size="small">
            {(commonFn.btnAuthorityFlag("Approval") && (
              <Tooltip
                placement="topLeft"
                title="Approval The Requests For Approval From Employee"
              >
                <Button
                  className="btnAgreed"
                  style={{ marginRight: 0 }}
                  onClick={() => approveOrRejectFn("Approved")}
                >
                  <CheckOutlined />
                  Approval
                </Button>
              </Tooltip>
            )) ||
              null}
            {(commonFn.btnAuthorityFlag("Reject") && (
              <Tooltip
                placement="topLeft"
                title="Reject The Requests For Approval From Employee"
              >
                <Button
                  className="btnRefused"
                  style={{ marginLeft: 0 }}
                  onClick={() => approveOrRejectFn("Rejected")}
                >
                  <CloseOutlined />
                  Reject
                </Button>
              </Tooltip>
            )) ||
              null}
            {(commonFn.btnAuthorityFlag("SelectedAmount") && (
              <Button className="btnAmount" style={{ cursor: "text" }}>
                Selected Amount:
                {new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(
                  selectedList.length
                    ? selectedList
                        .map((item) => item.requestAmount || 0)
                        .reduce((acc, curr) => acc + curr, 0)
                    : 0
                )}
              </Button>
            )) ||
              null}
          </Space>
        </div>
      </CustomTableExtend>

      <CustomTable
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        rowSelection={rowSelection}
        rowKey="vendorPaymentId"
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
      />

      {/* modal */}
      <Modal
        title={
          <div style={{ fontSize: "24px", fontWeight: "bold", color: "red" }}>
            <MailOutlined style={{ marginRight: "8px" }} />
            APPROVAL CONFIRMATION
            <div
              style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
            ></div>
          </div>
        }
        centered
        maskClosable={false}
        open={openApproval}
        onCancel={() => {
          setOpenApproval(false);
          approvalForm.resetFields();
        }}
        confirmLoading={btnLoading}
        onOk={handleSubmit}
        width="30%"
      >
        <Form form={approvalForm} layout="vertical">
          <div style={{ marginBottom: "16px", fontSize: "20px" }}>
            Are you sure you want to request these checks to be approved?
          </div>

          <Form.Item
            name="transactionCount"
            label="How Many Transactions?"
            rules={[{ required: true }]}
            style={{ flex: 1 }}
          >
            <Select
              placeholder="Select option"
              options={[
                {
                  value: "1",
                  // label: "Request 1 transaction(s) to be Approved",
                  label: `${
                    approvedOrRejected === "Approved" ? "Approve" : "Reject"
                  } ${selectedList.length} Check(s).`,
                },
                // {
                //   value: "all",
                //   label: "Request All transaction(s) to be Approved",
                // },
              ]}
            />
          </Form.Item>

          {(approvedOrRejected === "Approved" && (
            <Form.Item
              name="noLimit"
              label={
                <span>
                  Do you want to approve the amount over{" "}
                  {
                    <span
                      style={{ color: "#a94442", textDecoration: "underline" }}
                    >
                      {new Intl.NumberFormat("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                      }).format(5000)}
                    </span>
                  }{" "}
                  with signature
                </span>
              }
              style={{ flex: 1 }}
            >
              <Select
                placeholder="Select option"
                options={[
                  {
                    value: "no",
                    label: "No",
                  },
                  {
                    value: "yes",
                    label: "Yes",
                  },
                ]}
              />
            </Form.Item>
          )) ||
            null}

          {(approvedOrRejected !== "Approved" && (
            <Form.Item
              name="rejectedReason"
              label="Rejected Reason"
              style={{ flex: 2 }}
            >
              <Input placeholder="" />
            </Form.Item>
          )) ||
            null}
        </Form>
      </Modal>

      <Modal
        title={
          <div style={{ fontSize: "24px", fontWeight: "bold", color: "red" }}>
            <MailOutlined style={{ marginRight: "8px" }} />
            PRINT CASHIER CHECK CONFIRMATION
            <div
              style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
            ></div>
          </div>
        }
        centered
        open={openPrintModal}
        onCancel={() => {
          setOpenPrintModal(false);
          printForm.resetFields();
        }}
        onOk={handlePrintSubmit}
        width="50%"
      >
        <Form form={printForm} layout="vertical" initialValues={initialValues}>
          <div style={{ marginBottom: "16px", fontSize: "20px" }}>
            System Limited to 500 rows of Approved Records, Please select below
            items
          </div>
          <Form.Item
            name="transactionCount"
            label="How Many Transactions?"
            rules={[{ required: true }]}
            style={{ flex: 1 }}
          >
            <Select
              placeholder="Select option"
              options={[
                { value: "1", label: "Print all approved transactions" },
                // { value: "all", label: "Print all checks" }
              ]}
            />
          </Form.Item>

          <Form.Item
            name="postDate"
            label="Post Date"
            rules={[{ required: true, message: "Please select a date" }]}
          >
            <DatePicker
              style={{ width: "100%" }}
              format="MM/DD/YYYY"
              onChange={handleDateChange}
              disabled
              getPopupContainer={(trigger) => trigger.parentElement}
            />
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title={
          <div style={{ fontSize: "24px", fontWeight: "bold", color: "red" }}>
            <MailOutlined style={{ marginRight: "8px" }} />
            PRINT CASHIER CHECK CONFIRMATION
            <div
              style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
            ></div>
          </div>
        }
        centered
        open={openPrintCheckModal}
        onCancel={() => {
          setOpenPrintCheckModal(false);
          printCheckForm.resetFields();
        }}
        onOk={() => setOpenPrintCheckModal(false)}
        width="50%"
      >
        <Form
          form={printCheckForm}
          layout="vertical"
          initialCheckValues={initialCheckValues}
        >
          <div style={{ marginBottom: "16px", fontSize: "20px" }}>
            Are you sure you want to print these cashiers check(s)?
          </div>
          <Form.Item
            name="transactionCount"
            label="How Many Transactions?"
            rules={[{ required: true }]}
            style={{ flex: 1 }}
          >
            <Select
              placeholder="Select option"
              options={[
                { value: "1", label: "Print All Cashier Checks" },
                // { value: "all", label: "Print all checks" }
              ]}
            />
          </Form.Item>

          <Form.Item
            name="postDate"
            label="Post Date"
            rules={[{ required: true, message: "Please select a date" }]}
          >
            <DatePicker
              style={{ width: "100%" }}
              format="MM/DD/YYYY"
              onChange={handleDateCheckChange}
              getPopupContainer={(trigger) => trigger.parentElement}
            />
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title={
          <div style={{ fontSize: "24px", fontWeight: "bold", color: "red" }}>
            <MailOutlined style={{ marginRight: "8px" }} />
            RECORD CHECK CONFIRMATION
            <div
              style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
            ></div>
          </div>
        }
        centered
        open={openOnlyModal}
        onCancel={() => {
          setOpenOnlyModal(false);
          onlyForm.resetFields();
        }}
        onOk={() => setOpenPrintCheckModal(false)}
        width="50%"
      >
        <Form
          form={onlyForm}
          layout="vertical"
          initialOnlyValues={initialOnlyValues}
        >
          <div style={{ marginBottom: "16px", fontSize: "20px" }}>
            Are you sure you want to print these cashiers check(s)?
          </div>
          <Form.Item
            name="transactionCount"
            label="How Many Transactions?"
            rules={[{ required: true }]}
            style={{ flex: 1 }}
          >
            <Select
              placeholder="Select option"
              options={[
                { value: "1", label: "Record All Chencks" },
                // { value: "all", label: "Print all checks" }
              ]}
            />
          </Form.Item>

          <Form.Item
            name="transactionCount"
            label="Record By:"
            rules={[{ required: true }]}
            style={{ flex: 1 }}
          >
            <Select
              placeholder="Select option"
              options={[
                { value: "1", label: "Property" },
                { value: "2", label: "Transaction" },
                { value: "3", label: "Trust" },
                { value: "4", label: "Vendor Code" },
                { value: "5", label: "Invoice" },
              ]}
            />
          </Form.Item>

          <Form.Item
            name="postDate"
            label="Post Date"
            rules={[{ required: true, message: "Please select a date" }]}
          >
            <DatePicker
              style={{ width: "100%" }}
              format="MM/DD/YYYY"
              onChange={handleDateOnlyChange}
              getPopupContainer={(trigger) => trigger.parentElement}
            />
          </Form.Item>
        </Form>
      </Modal>

      <PDFModal ref={PDFModalRef} record={currentRecord} />
    </div>
  );
});
export default MainTable;
